// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3nPne","content":"styles_content__1WfsW","flexButton":"styles_flexButton__2euHe"};